import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';

const CancelSeriesModalInterestFee = ({ isOpen, onClose, onConfirm, seriesNo, seriesNoUid, loading }) => {
  const [reason, setReason] = useState('');

  const handleConfirm = () => {
    if (!reason.trim()) {
      alert('Please provide a reason for cancellation.');
      return;
    }
    onConfirm(seriesNoUid, reason);
    setReason('');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300 ease-in-out">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md transform transition-all duration-300 scale-100 sm:scale-95">
        <div className="p-6 border-b border-gray-100">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-semibold text-gray-800">
              Cancel Series: {seriesNo}
            </h2>
            <button
              onClick={onClose}
              className="text-gray-600 hover:text-gray-800 text-lg"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        </div>
        <div className="p-6">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Reason for Cancellation</label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
              rows="5"
              placeholder="Enter reason for cancellation"
            />
          </div>
        </div>
        <div className="p-6 border-t border-gray-100 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200"
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            className={`px-4 py-2 text-sm text-white bg-red-600 rounded-lg hover:bg-red-700 flex items-center gap-2 ${
              loading ? 'bg-red-400 cursor-not-allowed' : ''
            }`}
            disabled={loading}
          >
            {loading && <FontAwesomeIcon icon={faSpinner} className="animate-spin" />}
            Confirm Cancellation
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelSeriesModalInterestFee;